import { Box, Flex, Text } from '@chakra-ui/react';
import { Button, Modal } from '@morressier/alembic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons';

interface Props {
  onDelete: (subIndex: number) => void;
  onClose: () => void;
  isOpen: boolean;
  selectSubIndex: number;
}

export const DeleteSubFigureModal = ({
  onDelete,
  onClose,
  isOpen,
  selectSubIndex
}: Props) => {
  return (
    <Modal
      onClose={onClose}
      isOpen={isOpen}
      width="450px"
      closeButtonProps={{
        hidden: true
      }}
    >
      <Flex flexDirection={'column'} gap={4} padding={8}>
        <Box fontSize="40px" color={'actionSecondaryCautionContent'}>
          <FontAwesomeIcon icon={faExclamationTriangle} fontSize="42px" />
        </Box>
        <Text textStyle="headingGroup">Delete composite sub-figure?</Text>
        <Text textStyle="textBody">
          Do you confirm that you wish to delete this composite sub-figure? This
          action cannot be undone.
        </Text>
        <Flex flexDirection={'row'} gap={2} justifyContent="flex-end">
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="caution" onClick={() => onDelete(selectSubIndex)}>
            Delete
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};
